export default __webpack_public_path__ + "static/media/next.26f63a2d.svg";